const OPERATIONS = new Set(['load-list', 'restore-selection', 'save-selection', 'load-batches'])
const ERROR_CODES = new Set([
  'ERR_NETWORK', 'ERR_BAD_REQUEST', 'ERR_BAD_RESPONSE', 'ERR_CANCELED',
  'ECONNABORTED', 'ECONNRESET', 'ECONNREFUSED', 'ETIMEDOUT', 'ENOTFOUND',
])

export function logCollectionPointError(operation, error) {
  const details = { operation: OPERATIONS.has(operation) ? operation : 'unknown' }
  const status = error?.response?.status
  if (Number.isInteger(status) && status >= 100 && status <= 599) details.status = status
  if (ERROR_CODES.has(error?.code)) details.code = error.code
  console.error('[CollectionPoint] Falha na operação', details)
}
